<template>
  <b-overlay class="w-100" :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card
          :no-body="isDense"
          :bg-variant="isTransparent ? 'light' : ''"
          :class="[isTransparent ? 'shadow-none' : '', cardClass]"
        >
          <b-row>
            <b-col
              cols="12"
              v-if="$scopedSlots.title || $scopedSlots.titleBtn"
              class="mb-2"
            >
              <div
                class="w-100 d-flex flex-column flex-md-row align-items-center justify-content-between text-justify"
              >
                <!-- DONT TOCH THIS, IT'S FOR BACKWARD COMPATIBILITY -->
                <template v-if="isChildWrapper">
                  <h3><slot name="title"></slot></h3>
                </template>
                <template v-else-if="isDense && isTransparent">
                  <h1><slot name="title"></slot></h1>
                </template>
                <template v-else-if="!isDense">
                  <h1><slot name="title"></slot></h1>
                </template>
                <template v-else>
                  <h3><slot name="title"></slot></h3>
                </template>
                <slot name="titleBtn"></slot>
              </div>
            </b-col>
            <b-col cols="12" class="mb-1" v-if="hasFilters">
              <filters-wrapper @submitFilters="submitFilters">
                <slot name="filters"></slot>
              </filters-wrapper>
            </b-col>
            <b-col cols="12" v-if="isExtended">
              <div class="w-100 d-flex align-items-center mt-2">
                <slot name="extend"></slot>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <slot></slot>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <slot name="footer"></slot>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  emits: ["submitFilters"],
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isTransparent: {
      type: Boolean,
      default: false,
    },
    isChildWrapper: {
      type: Boolean,
      default: false,
    },
    isDense: {
      type: Boolean,
      default: false,
    },
    hasFilters: {
      type: Boolean,
      required: false,
      default: false,
    },
    isExtended: {
      type: Boolean,
      required: false,
      default: false,
    },
    cardClass: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    submitFilters() {
      this.$emit("submitFilters");
    },
  },
  components: { BCard, BRow, BCol, BOverlay, FiltersWrapper },
};
import FiltersWrapper from "@/views/components/Utils/FiltersWrapper.vue";
import { BCard, BRow, BCol, BOverlay } from "bootstrap-vue";
</script>
